import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Section } from '@/courses/models/section.model';
import Tools from '../../../providers/tools';
import { PRESENTATION_MODE_EVENTS } from '@/content/values/ed-presentation-mode.values';

@Component({
  name: 'ed-text-viewer-only'
})
export default class EdTextViewerOnly extends Vue {

  @Prop() readonly section: Section;

  text: string = '';
  changeObject = true;

  getText() {
    if(this.section.type === 'LESSON_TEXT') {
      this.text = this.section.text;
    } else {
      let htmlHash = JSON.parse(this.section.text).html;
      let htmlUrl = htmlHash ? this.section.assetsInfo.find(el => el.hash == htmlHash).url : null;
      if(htmlUrl) {
        fetch(htmlUrl)
          .then(response => response.text())
          .then(htmlString => {
            this.text = Tools.htmlDecode(htmlString) ?? ''; 
        });
      } else this.text = null;      
    }
  }

  get isPresentationMode() : boolean{
    return this.$store.state.CourseStore.isPresentationStudentMode || this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  mounted() {
    this.$edEventBus.$emit(PRESENTATION_MODE_EVENTS.LOAD_PRESENTATION_ELEMENTS);
    setTimeout(() =>  {
      this.getText();
      this.changeObject = false;
    }, 100)
  }

  @Watch('section')
  getHtml() {
    !this.changeObject && this.getText();
  }
}